export const POPOUT_V2_QUERY = "popoutv2";
export const POPOUT_V2_VALUE = "1";

export const PROJECTION_ROOT_ID = "_owa_projection_root";
export const PROJECTION_LOADING_ID = "_owa_projection_loading";

export const DEFAULT_PROJECTION_FLEX_PANE_WIDTH = 320;
